import request from './request'



// Obter detalhes do produto
export function addCart(data) {
  return request({
    url: `/cart/add`,
    method: 'post',
    data
  })
}

// Adicionar produto
export function swtichAll(data) {
  return request({
    url: '/cart/swtichAll',

    method: 'post',
    data
  })
}

// Adicionar produto
export function switchItem(data) {
  return request({
    url: '/cart/switchItem',
    method: 'post',
    data
  })
}

// Adicionar produto
export function delCart(data) {
  return request({
    url: '/cart/del',
    method: 'post',
    data
  })
}


// Adicionar produto
export function setCartNum(data) {
  return request({
    url: '/cart/setNums',
    method: 'post',
    data
  })
}

// Adicionar produto
export function listCart() {
  return request({
    url: '/cart/list',
    method: 'post'
  })
}

// Adicionar produto
export function cartbuy(data) {
  return request({
    url: '/cart/cartbuy',
    method: 'post',
    data
  })
}
// Adicionar produto
export function goodsbuy(data) {
  return request({
    url: '/cart/goodsbuy',
    method: 'post',
    data
  })
}


// Adicionar produto
export function getCartNum() {
  return request({
    url: '/cart/getCartNum',
    method: 'get',
  })
}